export default "__VITE_ASSET__CR$UqNzG__"